<div class="row">
  <div class="col-12">

    <h3>Please review and accept the Terms of Use.</h3>

    <div class="terms-of-use-container border mb-2" [innerHTML]="currentTermsOfUseResponse?.description"></div>

    <div class="form-group form-check">
      <input id="saveUserNameCheckBox" type="checkbox" class="form-check-input"
             [(ngModel)]="checkboxFlag" (change)="checkValue(checkboxFlag)" [disabled]="disableCheckbox">
      <label class="form-check-label" for="saveUserNameCheckBox">I agree to the Terms of Use displayed above.</label>
    </div>

  </div>
</div>
